module.exports = __webpack_public_path__ + "static/img/rechargeActivity.2de5459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rechargeActivity.png
// module id = JVzj
// module chunks = 4